import {makeAutoObservable, runInAction} from 'mobx';
import {ElasticSearchResult, IStorePage_ViewProduct} from './storepage.def';
import filtersStore from './components/filters/filters-store';
import {Portal} from '../util';

declare var StoreID: string;
declare var StoreName: string;
declare var __company_name: string;
declare var marketing_store_visit: any;
var _didRich = false;

class StorePageDataSource {
    public products: ElasticSearchResult;
    public matOptions: string[] = [];
    public mouldingOptions: string[] = [];
    public allow_reviews = true;
    public getExtraData = true;
    public didGoogle = false;

    constructor() {
        makeAutoObservable(this);
        this.allow_reviews = !Portal?.DisableReviews;
    }

    get hasProducts() {
        return this.products && !!this.products.hits.total.value;
    }

    async DoMarketingStorePage() {
        if (this.didGoogle) return;
        if (_didRich) return;

        const arr: ga4_item[] = [];
        const productMax = 40;
        this.didGoogle = true;
        _didRich = true;

        for (let i = 0; i < this.products?.hits?.hits?.length && i < productMax; i++) {
            const hit = this.products?.hits?.hits[i];

            let _jName = '';
            if (hit._source.fsi.GradSchoolID > 0 && hit._source.fsi.GSName) {
                _jName = `${hit._source.fsi.InstName} - ${hit._source.fsi.GSName} - ${hit._source.Name}`;
            } else if (!hit._source.fsi.GradSchoolID || hit._source.fsi.GradSchoolID < 1) {
                _jName = `${hit._source.fsi.InstName} - ${hit._source.Name}`;
            } else {
                _jName = hit._source.Name;
            }

            arr.push({
                item_id: hit._source.ItemID,
                product_id: hit._source.ProductID,
                item_name: _jName,
                currency: 'USD',
                index: i,
                item_brand: __company_name,
                item_category: hit._source.ProductTypeDisplayName,
                item_list_id: StoreID,
                item_list_name: StoreName,
                location_id: 'ChIJUcHLaPbi54kRtbVMrbSH4MU',
                price: hit._source.fsi.Price_Retail,
                quantity: 1,
                item_variant: 'original',
            });
        }

        runInAction(() => {
            this.didGoogle = true;
            _didRich = true;
        });

        marketing_store_visit(arr);

        const _ta = this.products?.hits?.hits.slice(0, productMax).map(x => x._source);

        this.injectStructuredData(_ta);
    }

    injectStructuredData(products: IStorePage_ViewProduct[]) {
        if (!Array.isArray(products)) return;

        const existingScripts = document.querySelectorAll('script[type="application/ld+json"][data-store-page-schema]');

        existingScripts.forEach(script => {
            script.remove();
        });

        const bodyScripts = document.body.querySelectorAll('script[type="application/ld+json"]');

        bodyScripts.forEach(script => {
            const scriptText = script.textContent || '';
            const isItemList = scriptText.includes('"@type": "ItemList"') && scriptText.includes('itemListElement') && !script.hasAttribute('data-store-page-schema');

            if (isItemList) {
                script.remove();
            }
        });

        const itemListElements = products.map((product, index) => ({
            '@type': 'ListItem',
            position: index + 1,
            item: {
                '@type': 'Product',
                name: product.Name,
                url: product.fsi.URL,
                image: product.CustomizationMethod === 2 ? `https://${Portal?.CDNDomain}/images/products/gen/products/${product.ImageItemID?.toLowerCase()}_${product.ProductID}_308_308.png` : product.Image_Thumb,
                sku: product.ItemID,
                offers: {
                    '@type': 'Offer',
                    availability: 'https://schema.org/InStock',
                    itemCondition: 'https://schema.org/NewCondition',
                    price: product.fsi.priceMSRP,
                    priceCurrency: 'USD',
                },
                countryOfAssembly: 'USA',
            },
        }));

        const structuredData = {
            '@context': 'https://schema.org',
            '@type': 'ItemList',
            itemListElement: itemListElements,
        };
        const script = document.createElement('script');

        script.type = 'application/ld+json';
        script.setAttribute('data-store-page-schema', 'true');
        script.text = JSON.stringify(structuredData);

        if (document.head) {
            document.head.appendChild(script);
        }
    }

    getFilterOptions() {
        filtersStore.getMatOptions();
        filtersStore.getMouldingOptions();
    }

    stripPaginationAriaAttributes() {
        const paginationUl = document.querySelector('ul.pagination');

        if (paginationUl) {
            paginationUl.removeAttribute('role');
            paginationUl.removeAttribute('aria-label');
        }
    }

    getExtra() {
        if (this.hasProducts) {
            this.DoMarketingStorePage();
        }

        if (this.getExtraData) {
            this.getFilterOptions();
            setTimeout(this.stripPaginationAriaAttributes, 10);
        }

        this.getExtraData = false;
    }
}

const storePageDataSource = new StorePageDataSource();

export default storePageDataSource;
